module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-90.a3fbfcc9.svg";